<button
  type="button"
  class="btn btn-primary ml-05"
  name="basesearchmodalButton"
  (click)="showChildModal()"
>
  <i class="fa fa-search"></i>
</button>
<div
  bsModal
  #basesearchmodal="bs-modal"
  [config]="{backdrop: 'static'}"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{visuals.title}}</h4>
        <button
          type="button"
          class="close pull-right"
          name="basesearchmodalCloseButton"
          aria-label="Close"
          (click)="hideChildModal()"
        >
          <span aria-hidden="true"><i class="fa fa-close"></i></span>
        </button>
      </div>

      <div class="modal-body">
        <dynamic-form
          [group]="group"
          [serviceName]="serviceName"
          [loading]="loading"
          [visuals]="visuals"
          [genericVisuals]="genericVisuals"
          [formErrors]="formErrors"
          #form="dynamicForm"
          (submit)="submit($event)"
          (modalOutput)="handleModalOutput($event)"
          (formChanges)="handleFormChanges($event)"
        >
        </dynamic-form>

        <base-table-layout
          [records]="grid"
          [footer]="footer"
          [gridActions]="gridActions"
          [hasRowCheckbox]="hasRowCheckbox"
          [settings]="columnSetting"
          [searched]="searched"
          [loading]="loading"
          [downloading]="downloading"
          [checkboxLoading]="checkboxLoading"
          [count]="count"
          [visuals]="visuals"
          [genericVisuals]="genericVisuals"
          (outputMethodHandler)="outputMethodHandler($event)"
          [sortNum]="sortNum"
          [sortDir]="sortDir"
          (changeSortHandler)="changeSort($event)"
          [pageSize]="pageSize"
          [pageNum]="pageNum"
          [pageMax]="pageMax"
          (changePageHandler)="changePage($event)"
          (changePageSizeHandler)="changePageSize($event)"
        >
        </base-table-layout>
      </div>
    </div>
  </div>
</div>
